import React from 'react';
import PropTypes from 'prop-types';

import PortalHeader from '../PortalHeader';
import WatchScroll from '../WatchScroll';

const propTypes = {
  hidePublish: PropTypes.bool,
  user: PropTypes.instanceOf(Object),
  logIn: PropTypes.func,
  logOut: PropTypes.func,
  backButton: PropTypes.instanceOf(Object),
  noLoginModal: PropTypes.bool,
  portalDomain: PropTypes.string,
  accountDomain: PropTypes.string,
  authBasePrefix: PropTypes.string,
  myCasaDomain: PropTypes.string,
  mobileOs: PropTypes.string,
  fromPortal: PropTypes.bool,
};
const defaultProps = {
  hidePublish: false,
  user: null,
  logIn: () => {},
  logOut: () => {},
  backButton: null,
  noLoginModal: false,
  portalDomain: 'https://www.casa.it',
  accountDomain: 'https://www.casa.it',
  authBasePrefix: '/my',
  myCasaDomain: 'https://www.casa.it',
  mobileOs: '',
  fromPortal: false,
};

const PortalHeaderHP = ({
  hidePublish,
  user,
  logIn,
  logOut,
  backButton,
  noLoginModal,
  portalDomain,
  accountDomain,
  authBasePrefix,
  myCasaDomain,
  mobileOs,
  fromPortal,
}) => (
  <WatchScroll>
  {
    (scrollInfos) => {
      const { coords, dir } = scrollInfos;
      const isTransparent = !coords || coords < 60;
      const isFixed = coords ? coords > 500 : false;
      const isHidden = coords ? coords > 60 && coords < 500 : false;
      const isHiding = dir && dir === 'up' && coords && coords > 60 ? true : false;
      return (
        <PortalHeader
          isTransparent={isTransparent}
          isFixed={isFixed}
          isHidden={isHidden}
          isHiding={isHiding}
          logIn={logIn}
          logOut={logOut}
          hidePublish={hidePublish}
          user={user}
          backButton={backButton}
          noLoginModal={noLoginModal}
          portalDomain={portalDomain}
          accountDomain={accountDomain}
          authBasePrefix={authBasePrefix}
          myCasaDomain={myCasaDomain}
          mobileOs={mobileOs}
          fromPortal={fromPortal}
          isHp
        />
      )
    }
  }
</WatchScroll>
);

PortalHeaderHP.propTypes = propTypes;
PortalHeaderHP.defaultProps = defaultProps;
export default PortalHeaderHP;